export const convertIndexToChar = (index: number): string => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (index < alphabet.length) {
    return alphabet[index];
  }

  return convertIndexToChar(Math.floor(index / alphabet.length) - 1) + convertIndexToChar(index % alphabet.length);
};

export default convertIndexToChar;
